export const TAGS_LOADED = 'tags/tagsLoaded';
export const TAGS_UPDATED = 'TAGS_UPADTED';
export const TAG_UPDATED = 'tags/tagsUpdated';
export const TAG_DELETED = 'tags/tagsDeleted';
